module.exports = __webpack_public_path__ + "static/media/homeOwnershipPostsBG.ec25ce78.png";